import { render, staticRenderFns } from "./ns-global-loader-vue.vue?vue&type=template&id=c3fa8312&scoped=true&"
import script from "./ns-global-loader-vue.vue?vue&type=script&lang=js&"
export * from "./ns-global-loader-vue.vue?vue&type=script&lang=js&"
import style0 from "./ns-global-loader-vue.vue?vue&type=style&index=0&id=c3fa8312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fa8312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3fa8312')) {
      api.createRecord('c3fa8312', component.options)
    } else {
      api.reload('c3fa8312', component.options)
    }
    module.hot.accept("./ns-global-loader-vue.vue?vue&type=template&id=c3fa8312&scoped=true&", function () {
      api.rerender('c3fa8312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-app-elements/src/ns-global-loader/ns-global-loader-vue.vue"
export default component.exports